// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/EntityFinancials/EntityFinancialsTable.css */

.financials-table-container {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-top: 16px;
}

.financials-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.financials-header h4 {
  margin: 0;
  color: #2C3E50;
  font-size: 16px;
}

.financials-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.financials-loading {
  text-align: center;
  padding: 24px;
  color: #7F8C8D;
}

.no-financials {
  text-align: center;
  padding: 24px;
  color: #7F8C8D;
  background-color: white;
  border-radius: 4px;
  border: 1px dashed #BDC3C7;
}

.add-financials-btn {
  padding: 8px 16px;
  background-color: #F39C12;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-financials-btn:hover {
  background-color: #D68910;
}

/* Financials Details */
.financials-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.financials-section {
  background-color: white;
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.financials-section h5 {
  margin: 0 0 12px 0;
  color: #34495E;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #ECF0F1;
  padding-bottom: 8px;
}

.financials-table {
  width: 100%;
  border-collapse: collapse;
}

.financials-table td {
  padding: 8px 4px;
  border-bottom: 1px solid #ECF0F1;
}

.financials-table td:first-child {
  color: #7F8C8D;
  font-size: 13px;
}

.financials-table td.amount {
  text-align: right;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 13px;
  color: #2C3E50;
}

.financials-table td.positive {
  color: #27AE60;
}

.financials-table td.negative {
  color: #E74C3C;
}

.financials-table td.dividend {
  color: #8E44AD;
}

.financials-table tr.date-row td {
  font-size: 12px;
  color: #7F8C8D;
  padding-top: 4px;
  padding-bottom: 4px;
}

.financials-table td.date-value {
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 12px;
}

.financials-table tr.subtotal td {
  border-top: 2px solid #BDC3C7;
  padding-top: 12px;
}

.financials-table tr.highlight td {
  background-color: #FEF9E7;
}

.financials-table tr.total td {
  background-color: #E8F6FF;
  font-size: 15px;
}

/* Actions */
.financials-actions-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.financials-actions-row .edit-btn,
.financials-actions-row .delete-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

.financials-actions-row .edit-btn {
  background-color: #3498DB;
  color: white;
}

.financials-actions-row .edit-btn:hover {
  background-color: #2980B9;
}

.financials-actions-row .delete-btn {
  background-color: #E74C3C;
  color: white;
}

.financials-actions-row .delete-btn:hover {
  background-color: #C0392B;
}
`, "",{"version":3,"sources":["webpack://./src/components/EntityFinancials/EntityFinancialsTable.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* src/components/EntityFinancials/EntityFinancialsTable.css */\n\n.financials-table-container {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.financials-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.financials-header h4 {\n  margin: 0;\n  color: #2C3E50;\n  font-size: 16px;\n}\n\n.financials-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.financials-loading {\n  text-align: center;\n  padding: 24px;\n  color: #7F8C8D;\n}\n\n.no-financials {\n  text-align: center;\n  padding: 24px;\n  color: #7F8C8D;\n  background-color: white;\n  border-radius: 4px;\n  border: 1px dashed #BDC3C7;\n}\n\n.add-financials-btn {\n  padding: 8px 16px;\n  background-color: #F39C12;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-financials-btn:hover {\n  background-color: #D68910;\n}\n\n/* Financials Details */\n.financials-details {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.financials-section {\n  background-color: white;\n  border-radius: 4px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.financials-section h5 {\n  margin: 0 0 12px 0;\n  color: #34495E;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #ECF0F1;\n  padding-bottom: 8px;\n}\n\n.financials-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.financials-table td {\n  padding: 8px 4px;\n  border-bottom: 1px solid #ECF0F1;\n}\n\n.financials-table td:first-child {\n  color: #7F8C8D;\n  font-size: 13px;\n}\n\n.financials-table td.amount {\n  text-align: right;\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 13px;\n  color: #2C3E50;\n}\n\n.financials-table td.positive {\n  color: #27AE60;\n}\n\n.financials-table td.negative {\n  color: #E74C3C;\n}\n\n.financials-table td.dividend {\n  color: #8E44AD;\n}\n\n.financials-table tr.date-row td {\n  font-size: 12px;\n  color: #7F8C8D;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.financials-table td.date-value {\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 12px;\n}\n\n.financials-table tr.subtotal td {\n  border-top: 2px solid #BDC3C7;\n  padding-top: 12px;\n}\n\n.financials-table tr.highlight td {\n  background-color: #FEF9E7;\n}\n\n.financials-table tr.total td {\n  background-color: #E8F6FF;\n  font-size: 15px;\n}\n\n/* Actions */\n.financials-actions-row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.financials-actions-row .edit-btn,\n.financials-actions-row .delete-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.financials-actions-row .edit-btn {\n  background-color: #3498DB;\n  color: white;\n}\n\n.financials-actions-row .edit-btn:hover {\n  background-color: #2980B9;\n}\n\n.financials-actions-row .delete-btn {\n  background-color: #E74C3C;\n  color: white;\n}\n\n.financials-actions-row .delete-btn:hover {\n  background-color: #C0392B;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
